import React from 'react';
import { SLA } from '../rules/SLA';
import { BaseTab } from './BaseTab';

export const CaseUrgencyTab: React.FC = () => {
  return (
    <BaseTab>
      <SLA />
    </BaseTab>
  );
};
